import { graphql } from '@graphql/gql';

export const SEARCH_ATTENDEES = graphql(`
  query SEARCH_ATTENDEES($criteria: AttendeeSearchCriteria) {
    searchAttendees(criteria: $criteria) {
      pagination {
        limit
        totalCount
        currentToken
        nextToken
      }
      data {
        id
        contactId
        firstName
        lastName
        title
        company
        profilePicture
        canMeet
        guest
        connectionStatus
        designation
        prefix
        virtual
      }
    }
  }
`);
